// TODO: the first will be removed when complete the POST task
/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable react/no-danger */
import { useContext, useEffect, useState } from 'react';

import axios from 'axios';
import { Container, LoadingOlist } from 'components/layout';
import { AuthContext } from 'contexts/auth';
import { API_URLS } from 'pages/leads/constants';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAsyncFn } from 'react-use';

import { Button, Flex } from '@olist/united';

import { getRegion } from '../../helpers/i18n.helpers';
import { ButtonsWrapper, TermsOfServiceWrapper } from './terms-of-service.style';

const TermsOfService = () => {
  const { t } = useTranslation();

  const history = useHistory();
  const { userInfo } = useContext(AuthContext);

  const region = getRegion();

  const [shouldAccept, setShouldAccept] = useState(false);
  const [hasRead, setHasRead] = useState(false);
  const [termsVersion, setTermsVersion] = useState(null);
  const [termsContent, setTermsContent] = useState(null);

  const [{ error, loading: isLoading, value: termsData }, fetchTerms] = useAsyncFn(async (url) =>
    axios.get(url, {
      headers: { region },
    })
  );
  const [{ error: errorAccept, loading: isLoadingAccept, value: acceptData }, postTerms] =
    useAsyncFn(async (url, body) =>
      axios.post(url, body, {
        headers: { region },
      })
    );

  const postAccept = () => {
    if (termsVersion) postTerms(API_URLS.postAcceptTerms, { termsVersion });
  };

  useEffect(() => {
    if (acceptData && acceptData.data) {
      window.location.href = acceptData.data.redirectUrl;
    }
  }, [acceptData]);

  const checkHasFulfillment = (permissions: Array<{ permission: string; active: boolean }>) => {
    return (
      permissions?.length &&
      permissions.find((item) => {
        const canUseFulFillment = item.permission === 'can_use_fulfillment_by_olist';
        const isActive = item.active === true;
        return canUseFulFillment && isActive;
      })
    );
  };

  useEffect(() => {
    if (userInfo?.permissions) {
      const hasFulfillment = checkHasFulfillment(userInfo.permissions);
      if (hasFulfillment) {
        fetchTerms(API_URLS.getFulfillmentTerms);
      } else {
        fetchTerms(API_URLS.getTermsOfService);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.permissions]);

  useEffect(() => {
    if (termsData?.data && userInfo) {
      const { data: terms } = termsData as any;
      const shouldAcceptTerms = !(userInfo.termsOfUseVersion === Number(terms.version));
      setShouldAccept(shouldAcceptTerms);
      setTermsVersion(terms.version);
      setTermsContent(terms.content);
    }
  }, [termsData, userInfo]);

  if (isLoading || !termsData) return <LoadingOlist />;

  window.onscroll = function scrollY() {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
      if (!hasRead && termsData) {
        setHasRead(true);
      }
    }
  };

  const disableAccept = !hasRead || !termsContent;

  return (
    <Flex flexDirection="column">
      <TermsOfServiceWrapper>
        {termsContent && <div dangerouslySetInnerHTML={{ __html: termsContent }} />}
      </TermsOfServiceWrapper>
      <ButtonsWrapper>
        <Container>
          <Flex justifyContent="flex-end" flexDirection={['column', 'column', 'row']}>
            {shouldAccept ? (
              <Button
                variation="alternate"
                disabled={disableAccept || isLoadingAccept}
                onClick={postAccept}
                loading={isLoadingAccept}
              >
                {t`accept`}
              </Button>
            ) : (
              <Button onClick={() => history.goBack()}>{t`back`}</Button>
            )}
          </Flex>
        </Container>
      </ButtonsWrapper>
    </Flex>
  );
};

export default TermsOfService;
